import CodeMirror from 'codemirror';
import './searchcursor';
import * as actions from '../../redux/scriptEditor/actions.scriptEditor';
import store from '../../store';

CodeMirror.defineOption("search", {bottom: false});

function searchOverlay(query, caseInsensitive) {
    query = getQueryRegExp(query, caseInsensitive);
    return {
        token: function(stream) {
            query.lastIndex = stream.pos;
            var match = query.exec(stream.string);
            if (match && match.index === stream.pos) {
                stream.pos += match[0].length || 1;
                return 'searching';
            } else if (match) {
                stream.pos = match.index;
            } else {
                stream.skipToEnd();
            }
        }
    };
}

function setSearchResultCounter(cm, query, customCursor) {

    var counter = {
        currentSearchResult: 0,
        allSearchResults: 0
    };

    var curQuery = getQueryRegExp(query, queryCaseInsensitive(query));

    var currentResult = 0;
    var cursor = customCursor || cm.getCursor();
    var startCh = cursor.ch - query.length;
    var lineInd = 0;

    counter.allSearchResults = (cm.getValue().match(curQuery) || []).length;

    cm.eachLine(function (cmLine) {
        if (lineInd < cursor.line) {
            currentResult += (cmLine.text.match(curQuery) || []).length;
        } else if (lineInd === cursor.line) {
            var match;
            while ((match = curQuery.exec(cmLine.text)) != null) {
                currentResult += 1;
                if (match.index === startCh) {
                    break;
                }

                if (currentResult > counter.allSearchResults) {
                    break;
                }
            }
        }
        lineInd++;
    });
    counter.currentSearchResult = currentResult;

    store.dispatch(actions.setMeta({
        searchKey: cm.options.searchKey,
        totalSearchResults: counter.allSearchResults,
        currentSearchItem: counter.currentSearchResult,
    }));

    return counter;
}

function SearchState() {
    this.posFrom = this.posTo = this.lastQuery = this.query = null;
    this.overlay = null;
}

function getSearchState(cm) {
    return cm.state.search || (cm.state.search = new SearchState());
}

function queryCaseInsensitive(query) {
    return typeof query === 'string' && query === query.toLowerCase();
}

function getSearchCursor(cm, query, pos) {
    // Heuristic: if the query string is all lowercase, do a case insensitive search.
    return cm.getSearchCursor(query, pos, {caseFold: true, multiline: true});
}

function getQueryRegExp(query, caseInsensitive) {
    if (typeof query === "string") {
        return new RegExp(query.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), caseInsensitive ? "gi" : "gi");
    } else {
        return query;
    }
}

function parseString(string) {
    return string;
}

function parseQuery(query) {
    // var isRE = query.match(/^\/(.*)\/([a-z]*)$/);
    // if (isRE) {
    //     try { query = new RegExp(isRE[1], isRE[2].indexOf("i") == -1 ? "" : "i"); }
    //     catch(e) {} // Not a regular expression after all, do a string search
    // } else {
    //     query = parseString(query)
    // }
    try {
        query = new RegExp(isRE[1], isRE[2].indexOf("i") == -1 ? "" : "i");
    } catch(e) {
        query = parseString(query)
    }

    if (typeof query == "string" ? query == "" : query.test(""))
        query = /x^/;
    return query;
}

function startSearch(cm, state, query) {
    state.queryText = query;
    state.query = parseQuery(query);
    cm.removeOverlay(state.overlay, queryCaseInsensitive(state.query));
    state.overlay = searchOverlay(state.query, queryCaseInsensitive(state.query));
    cm.addOverlay(state.overlay);
    if (cm.showMatchesOnScrollbar) {
        if (state.annotate) { state.annotate.clear(); state.annotate = null; }
        state.annotate = cm.showMatchesOnScrollbar(state.query, queryCaseInsensitive(state.query));
    }
}

function getSearchPanelData(cm){
    const stateRedux = store.getState();
    return stateRedux.scriptEditor.searchPanels[cm.options.searchKey];
}

function doSearch(cm, rev, persistent) {
    var state = getSearchState(cm);
    const query = getSearchPanelData(cm)?.searchTerm || '';
    var q = query || cm.getSelection() || null;
    if (q instanceof RegExp && q.source === "x^") q = null;
    if (persistent) {
        if (q) {
            state.posFrom = cm.getCursor(true);
            state.posTo = cm.getCursor();
            startSearch(cm, state, q);
            setSearchResultCounter(cm, query);
        }
    } else {
        startSearch(cm, state, q);
        state.posFrom = cm.getCursor(true);
        state.posTo = cm.getCursor();
        findNext(cm, rev);
    }
}

function findNext(cm, rev) {cm.operation(function() {
    var state = getSearchState(cm);
    var cursor = getSearchCursor(cm, state.query, rev ? state.posFrom : state.posTo);
    if (!cursor.find(rev)) {
        cursor = getSearchCursor(cm, state.query, rev ? CodeMirror.Pos(cm.lastLine()) : CodeMirror.Pos(cm.firstLine(), 0));
        if (!cursor.find(rev)) {
            setSearchResultCounter(cm, state.query);
            return;
        }
    }
    cm.setSelection(cursor.from(), cursor.to());
    cm.scrollIntoView({from: cursor.from(), to: cursor.to()}, 20);
    state.posFrom = cursor.from();
    state.posTo = cursor.to();
    setSearchResultCounter(cm, state.query);
});}

function clearSearch(cm) {cm.operation(function() {
    var state = getSearchState(cm);
    state.query = state.queryText = null;
    cm.removeOverlay(state.overlay);
    if (state.annotate) {
        state.annotate.clear();
        state.annotate = null;
    }
});}

function replaceAll(cm, query, text) {
    cm.operation(function() {
        for (var cursor = getSearchCursor(cm, query); cursor.findNext();) {
            if (typeof query != "string") {
                var match = cm.getRange(cursor.from(), cursor.to()).match(query);
                cursor.replace(text.replace(/\$(\d)/g, function(_, i) {return match[i];}), 'replace');
            } else {
                cursor.replace(text, 'replace');
            }
        }
    });
}

function replaceText(cm, query, text, all) {
    text = parseString(text)
    if (all) {
        replaceAll(cm, query, text);
        setSearchResultCounter(cm, query);
    } else {
        clearSearch(cm);
        var cursor = getSearchCursor(cm, query, cm.getCursor("from"));
        var advance = function() {
            var start = cursor.from(), match;
            if (!(match = cursor.findNext())) {
                cursor = getSearchCursor(cm, query);
                if (!(match = cursor.findNext()) ||
                    (start && cursor.from().line == start.line && cursor.from().ch == start.ch)) return;
            }
            cm.setSelection(cursor.from(), cursor.to());
            cm.scrollIntoView({from: cursor.from(), to: cursor.to()});
            doReplace(match);
        };
        var doReplace = function(match) {
            cursor.replace(typeof query == "string" ? text :
                text.replace(/\$(\d)/g, function(_, i) {return match[i];}), 'replace');
            if (cursor.findNext()) {
                cm.setSelection(cursor.from(), cursor.to());
            }
            setSearchResultCounter(cm, query);
        };
        advance();
    }
}

CodeMirror.commands.findUpdate = function(cm) {
    const query = getSearchPanelData(cm)?.searchTerm || '';
    clearSearch(cm);
    if (query) {
        const stateCm = getSearchState(cm);
        doSearch(cm, false, true, true);
        const cursor = getSearchCursor(cm, query, stateCm.posFrom);
        const matches = cursor.matches(false, stateCm.posFrom);
        if (matches) {
            const { from, to } = matches;
            cm.setSelection(from, to);
            cm.scrollIntoView({from, to}, 20);
            setSearchResultCounter(cm, query);
        }
    }
};

CodeMirror.commands.searchTextUpdate = function(cm) {
    const query = getSearchPanelData(cm)?.searchTerm || '';
    clearSearch(cm);
    if (query) {
        const stateCm = getSearchState(cm);
        doSearch(cm, false, true, true);
    }
};

CodeMirror.commands.findPersistent = function(cm) {
    const query = getSearchPanelData(cm)?.searchTerm || '';
    var q = cm.getSelection() || query;
    if (q instanceof RegExp && q.source === "x^") q = null;
    store.dispatch(actions.setSearchTerm({ searchKey: cm.options.searchKey, searchTerm: q || '' }));
    store.dispatch(actions.showSearch({
        searchKey: cm.options.searchKey,
        showSearch: true,
        showReplace: false,
    }));
    clearSearch(cm);
    doSearch(cm, false, true);
};
CodeMirror.commands.replace = function(cm) {
    const query = getSearchPanelData(cm)?.searchTerm || '';
    var q = cm.getSelection() || query;
    if (q instanceof RegExp && q.source === "x^") q = null;
    store.dispatch(actions.setSearchTerm({ searchKey: cm.options.searchKey, searchTerm: q || '' }));
    clearSearch(cm);
    doSearch(cm, false, true);
    store.dispatch(actions.showSearch({
        searchKey: cm.options.searchKey,
        showSearch: true,
        showReplace: true,
    }));
    store.dispatch(actions.searchUpdate({ searchKey: cm.options.searchKey}));
};
CodeMirror.commands.replaceNext = function(cm) {
    const query = getSearchPanelData(cm)?.searchTerm || '';
    const text = getSearchPanelData(cm)?.replaceTerm || '';
    const curQuery = getQueryRegExp(query, queryCaseInsensitive(query));
    replaceText(cm, curQuery, text);
    doSearch(cm, false, true);
    store.dispatch(actions.searchUpdate({ searchKey: cm.options.searchKey}));
};
CodeMirror.commands.findPersistentNext = function(cm) {
    doSearch(cm, false);
};
CodeMirror.commands.findPersistentPrev = function(cm) {
    doSearch(cm, true);
};
CodeMirror.commands.findNext = function(cm) {
    if (getSearchPanelData(cm)?.showSearch) {
        CodeMirror.commands.findPersistentNext(cm);
    } else {
        CodeMirror.commands.findPersistent(cm);
    }
};
CodeMirror.commands.findPrev = function(cm) {
    if (getSearchPanelData(cm)?.showSearch) {
        CodeMirror.commands.findPersistentPrev(cm);
    } else {
        CodeMirror.commands.findPersistent(cm);
    }
};
CodeMirror.commands.clearSearch = clearSearch;
CodeMirror.commands.closeSearch = (cm) => {
    store.dispatch(actions.setSearchTerm({ searchKey: cm.options.searchKey,searchTerm:''}));
    store.dispatch(actions.showSearch({
        searchKey: cm.options.searchKey,
        showSearch: false,
        showReplace: false,
    }));
    clearSearch(cm);
};
CodeMirror.commands.replaceAll = function(cm) {
    const query = getSearchPanelData(cm)?.searchTerm || '';
    const text = getSearchPanelData(cm)?.replaceTerm || '';
    const curQuery = getQueryRegExp(query, queryCaseInsensitive(query));
    replaceText(cm, curQuery, text, true);
    store.dispatch(actions.searchUpdate({ searchKey: cm.options.searchKey}));
};
